module.exports = __webpack_public_path__ + "img/arin.aedca9f9.png";